// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"152":"notification-detail","602":"notification","966":"login"}[chunkId] + "." + {"152":"1d4c8280","602":"c9232ab5","966":"9bef43a7"}[chunkId] + ".css";
};